<template>
  <div class="footer" :style="dx == 1 ? 'padding-bottom:22px' : 'padding-bottom:0px'">
    <div class="footer-item"  v-for='(item,index) of items' :class='[ {on:index === idx} ]' @click="tz(item.push)">
      <img :src="index === idx ? item.imgActive : item.imgUrl"/>
      <div>{{item.name}}</div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
	export default {
    data() {
      return {
        items: [
          {
            name: "首页",
            imgUrl:require('../../assets/images/home.png'),
            imgActive:require('../../assets/images/home-active.png'),
            push: "/main/juka"
          },
          {
            name: "我是团长",
            imgUrl:require('../../assets/images/hb.png'),
            imgActive:require('../../assets/images/hb-active.png'),
            push: "/main/gathermanage"
          },
          {
            name: "我的",
            imgUrl:require('../../assets/images/me.png'),
            imgActive:require('../../assets/images/me-active.png'),
            push: "/main/mjuka"
          }
        ]
      }
    },
    methods: {
      tz:function(url){
        location.href = url
      },
    },
    props: ['idx','dx']
	}
</script>

<style>
  .footer,.footers{
    display: flex;
    width: 100%;
    height: 48px;
    background:#fff;
    position:fixed;
    bottom:0;
    border-top:solid 1px rgba(102,102,102,0.1);
    left:0;
    z-index:99
  }
  .footer .footer-item,.footers .footer-item{
    flex: 1;
    text-align: center;
    font-size: 13px;
    color: #666;
    padding-top:2px;
    font-weight:bold
  }
  .footer .footer-item img,.footers .footer-item img{
    display:block;
    width:26px;
    margin:0 auto;
  }
  .footer .on{
    color:#2c2c2c
  }
</style>
